import { BackgroundCheckColumns } from '@/backend/features/background-check/shared';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { ExtendedAccountColumns } from '@/backend/features/contact-management/entities/extended-account/types';
import { mapBackgroundCheckFilter } from '@/ui/features/background-check/utils/mapBackgroundCheckFilter';
import { ExtendedAccountFilterData } from '@/ui/features/contact-management/AccountsPanel/types';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { getAccountsManageFilter } from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';
import { Filter } from '@juvare/platform-shared/features/storage';

export function mapBackgroundCheckToFilter({
    enabledTypes,
    filterData,
    userState,
    expiringOnlyFilters,
    accountFilters,
}: {
    enabledTypes: BackgroundCheckType[];
    filterData: ExtendedAccountFilterData;
    userState: UserState;
    expiringOnlyFilters: Filter<BackgroundCheckColumns>[];
    accountFilters?: Filter<ExtendedAccountColumns>[];
}) {
    const { filter: backgroundCheckFilter, defaultFilters: defaultBackgroundCheckFilters } = mapBackgroundCheckFilter(
        enabledTypes,
        filterData,
        expiringOnlyFilters,
    );

    const filter = [...backgroundCheckFilter];
    const defaultFilters = [...defaultBackgroundCheckFilters];

    filter.push({
        column: 'accountId',
        op: 'in',
        subFilter: {
            entity: accountEntityName,
            filter: [...(accountFilters ?? []), ...getAccountsManageFilter(userState)],
        },
    });

    return { filter, defaultFilters };
}
